import React, { useContext } from 'react';
import { string } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import { buildAddToCartRequest, buildAnalyticsCartEventObject } from '../../utils/promo-cart-utils';

export const PromoAddToCart = ({ itemId, displayPosition }) => {

  const { store } = useContext(ExperienceContext);
  const { promoCartItemsObj, isCartLoading, addToCart } = usePromoCart();
  const { products, analyticsSharedSection } = usePromoModel();

  const product = products.get(itemId);
  const promoItemModel = promoCartItemsObj[itemId];

  const cartRequest = buildAddToCartRequest({
    product: { ...product, displayPosition },
    promoItemModel: promoItemModel || {},
    desiredQuantity: 1,
    store,
  });

  const handleCartClick = () => {
    addToCart(cartRequest)
      .then((cartResponse) => {
        window.LIFE_CYCLE_EVENT_BUS.trigger('promotion-products-add-to-cart.success', {
          cartReqParams: cartRequest.CartRequest.itemDetails,
          cartOptions: { sharedSection: analyticsSharedSection, component: 'product pod' },
          cartInfo: buildAnalyticsCartEventObject(cartRequest, cartResponse),
        });
      });
  };

  return (
    <Button
      outline
      disabled={isCartLoading}
      onClick={handleCartClick}
    >
      Add To Cart
    </Button>
  );
};

PromoAddToCart.displayName = 'PromoAddToCart';

PromoAddToCart.propTypes = {
  itemId: string.isRequired,
  displayPosition: string.isRequired
};
